export default __webpack_public_path__ + "images/8a04a45bb6ea8be62e5d620708782058.svg";